import "./src/styles/normalize.css"
import "./src/styles/styles.scss"

export const onInitialClientRender = () => {
  const isIeBrowser = !!window.MSCompatibleInfo;
  if (isIeBrowser) {
    window.location.replace('/ie11.html');
  }
}